import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExcelService } from '@app/_core/services/excel.service';
import { SharedModule } from '@app/_shared/shared.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
//import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TreeTableModule } from 'primeng/treetable';

import { AssignAgentsComponent } from '../common/assign-agents/assign-agents.component';
import { AudioComponent } from '../common/audio/audio.component';
import { ConsoleSearchComponent } from '../common/console-search/console-search.component';
import { InteractionAuditComponent } from '../common/interaction-audit/interaction-audit.component';
import { MessageViewComponent } from '../common/message-view/message-view.component';
import { VideojsWavesurferComponent } from '../common/videojs-wavesurfer/videojs-wavesurfer.component';
import { AuditDetailsComponent } from './audits/audit-details/audit-details.component';
import { AuditsComponent } from './audits/audits.component';
import { AiAuditsComponent } from './ai-audits/ai-audits.component';
import { CampaignDetailsComponent } from './campaigns/campaign-details/campaign-details.component';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { NewCampaignComponent } from './campaigns/new-campaign/new-campaign.component';
import { ViewCampaignDetailsComponent } from './campaigns/view-campaign-details/view-campaign-details.component';
import { ConsoleComponent } from './console.component';
import { ConsoleRoutingModule } from './console-routing.module';
import { GroupDetailsComponent } from './groups/group-details/group-details.component';
import { GroupsComponent } from './groups/groups.component';
import { HistoricalmetricDetailsComponent } from './historicalmetrics/historicalmetric-details/historicalmetric-details.component';
import { HistoricalmetricsComponent } from './historicalmetrics/historicalmetrics.component';
import { InteractionDetailsComponent } from './interactions/interaction-details/interaction-details.component';
import { InteractionsComponent } from './interactions/interactions.component';
import { AiInteractionsComponent } from './ai-interactions/ai-interactions.component';
import { IvrDetailsComponent } from './ivrs/ivr-details/ivr-details.component';
import { IvrsComponent } from './ivrs/ivrs.component';
import { LivestatusDetailsComponent } from './livestatuses/livestatus-details/livestatus-details.component';
import { LivestatusesComponent } from './livestatuses/livestatuses.component';
import { LivestatusesAuditsComponent } from './livestatuses/livestatuses-audits/livestatuses-audits.component';
import { LivestatusesInteractionsComponent } from './livestatuses/livestatuses-interactions/livestatuses-interactions.component';
import { QueueDetailsComponent } from './queues/queue-details/queue-details.component';
import { QueuesComponent } from './queues/queues.component';
import { SkillDetailsComponent } from './skills/skill-details/skill-details.component';
import { SkillsComponent } from './skills/skills.component';
import { UsermenuvoicemailsComponent } from './usermenuvoicemail/usermenuvoicemails/usermenuvoicemails.component';
import { ViewVoicemailDetailsComponent } from './usermenuvoicemail/view-voicemail-details/view-voicemail-details.component';
import { VoicemailDetailsComponent } from './voicemails/voicemail-details/voicemail-details.component';
import { VoicemailsComponent } from './voicemails/voicemails.component';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { KnowledgeDocsComponent } from './knowledge-docs/knowledge-docs.component';

@NgModule({
  declarations: [
    ConsoleComponent,
    QueuesComponent,
    SkillsComponent,
    GroupsComponent,
    VoicemailsComponent,
    CampaignsComponent,
    IvrsComponent,
    InteractionsComponent,
    AiInteractionsComponent,
    AuditsComponent,
    AiAuditsComponent,
    LivestatusesComponent,
    HistoricalmetricsComponent,
    AuditDetailsComponent,
    CampaignDetailsComponent,
    GroupDetailsComponent,
    HistoricalmetricDetailsComponent,
    InteractionDetailsComponent,
    IvrDetailsComponent,
    LivestatusDetailsComponent,
    QueueDetailsComponent,
    SkillDetailsComponent,
    VoicemailDetailsComponent,
    AssignAgentsComponent,
    LivestatusesAuditsComponent,
    LivestatusesInteractionsComponent,
    AudioComponent,
    InteractionAuditComponent,
    ConsoleSearchComponent,
    MessageViewComponent,
    //VideojsWavesurferComponent,
    NewCampaignComponent,
    UsermenuvoicemailsComponent,
    ViewVoicemailDetailsComponent,
    ViewCampaignDetailsComponent,
    KnowledgeDocsComponent,
  ],
  imports: [
    CommonModule,
    ConsoleRoutingModule,
    TableModule,
    TreeTableModule,
    FormsModule,
    SharedModule,
    TabViewModule,
    //ConfirmDialogModule,
    DialogModule,
    InputSwitchModule,
    CalendarModule,
    AccordionModule.forRoot(),
    ReactiveFormsModule,
    ToastModule,
  ],
  providers: [ExcelService],
  exports: [],
})
export class ConsoleModule {}
